module.exports = __webpack_public_path__ + "static/img/nippo_scouter.d0965a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nippo_scouter.png
// module id = l0Mi
// module chunks = 1